(() => {
  const WRAP_ID = 'mounjaro-announcement-wrap';

  const setHeightVar = () => {
    const wrap = document.getElementById(WRAP_ID);
    if (!wrap) return;

    const bar = wrap.querySelector('.rot-ann') || wrap.querySelector('[id^="rot-ann-"]');
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty('--mj-announcement-h', `${h}px`);
  };

  const init = () => {
    setHeightVar();

    const wrap = document.getElementById(WRAP_ID);
    if (wrap && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(() => setHeightVar());
      ro.observe(wrap);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('resize', setHeightVar, { passive: true });
  document.addEventListener('shopify:section:load', setHeightVar);
})();